import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export default function InstallPrompt() {
  const [evt, setEvt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    try { if (localStorage.getItem("spora1_a2hs_dismissed")) return; } catch (e) { console.warn("Install prompt", e); }
    const handler = (e) => { e.preventDefault(); setEvt(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const dismiss = () => {
    try { localStorage.setItem("spora1_a2hs_dismissed", "1"); } catch (e) { console.warn("Install prompt", e); }
    setShow(false);
  };

  const install = async () => {
    if (!evt) return;
    evt.prompt();
    try { await evt.userChoice; } catch (e) { console.warn("Install prompt", e); }
    dismiss();
  };

  if (!show) return null;

  return (
    <div data-testid="install-banner"
      className="fixed inset-x-3 bottom-[76px] z-[60] mx-auto max-w-md rounded-2xl border border-border bg-card p-4 shadow-2xl md:inset-x-auto md:right-4 md:bottom-4 md:w-80">
      <button onClick={dismiss} data-testid="install-dismiss" aria-label="Dismiss"
        className="absolute right-2 top-2 rounded-lg p-1 text-muted-foreground hover:bg-accent hover:text-foreground">
        <X className="h-4 w-4" />
      </button>
      <div className="flex items-center gap-3">
        <img src="/logo192.png" alt="SPORA1" className="h-11 w-11 rounded-xl border border-border" />
        <div className="pr-4">
          <p className="font-display text-base font-bold leading-tight">Install SPORA1</p>
          <p className="text-xs text-muted-foreground">Add to your home screen for one-tap access.</p>
        </div>
      </div>
      <button onClick={install} data-testid="install-accept"
        className="mt-3 flex w-full items-center justify-center gap-2 rounded-lg bg-primary py-2.5 text-sm font-semibold text-primary-foreground transition-colors hover:bg-[#FF8533]">
        <Download className="h-4 w-4" /> Add to Home Screen
      </button>
    </div>
  );
}
